angular.module('wbControllers').controller 'AccountTransactionsController',
[ '$scope', 'railsResource', '$routeParams', '$location', 'Transactions',
($scope, $resource, $routeParams, $location, Transactions) ->
  @openDetails = null
  @filters = {}
  @range = { startDate: null, endDate: null }
  @accountId = $routeParams.id

  formatTransactionTypes = (list) =>
    # This formatting is so we can use these values in <filter-checklist>
    list.map (v) ->
      {
        'name': v.category
        'value': v.category
      }

  loadTransactions = =>
    @filters.transaction = if $location.search().transaction then $location.search().transaction else undefined
    @filters.symbol = if $location.search().symbol then $location.search().symbol else undefined
    @filters.description = if $location.search().description then $location.search().description else undefined
    @filters.quantity = {
      from: $location.search().quantityFrom
      to: $location.search().quantityTo
    }
    @filters.price = {
      from: $location.search().priceFrom
      to: $location.search().priceTo
    }
    @filters.value = {
      from: $location.search().valueFrom
      to: $location.search().valueTo
    }
    @page = if $location.search().page then $location.search().page else 1
    @limit = if $location.search().limit then $location.search().limit else 25
    @orderBy = $location.search().orderBy if $location.search().orderBy?
    @reverse = $location.search().reverse if $location.search().reverse?
    @startDate = if isNaN(Date.parse($location.search().startDate)) then @range.startDate else $location.search().startDate
    @endDate = if isNaN(Date.parse($location.search().endDate)) then @range.endDate else $location.search().endDate

    @transactions = Transactions.get {
      id: $routeParams.id
      startDate: @startDate
      endDate: @endDate
      page: @page
      limit: @limit
      orderBy: @orderBy
      reverse: @reverse
      filters: @filters
    }, (transactions) =>
      @account = transactions.metadata.investmentAccount
      @user = transactions.metadata.user
      @transactionTypes = formatTransactionTypes(transactions.metadata.transactionTypes)
  $scope.toggleDetails = (i) =>
    if @openDetails == i
      @openDetails = null
    else
      @openDetails = i

  $scope.displayCurrencyValue = (transaction, prop) =>
    value = transaction[prop]
    if (transaction.transactionType == "DVR" && (value == 0) || !value) then '-' else value

  $scope.$watch 'ctrl.range', loadTransactions
  $scope.$on '$routeUpdate', loadTransactions

  loadTransactions()
  @
]
